const dashboard = {
    title: 'Dashboard',
    subtitle: 'Monitor your API products and automation performance',
    
    // Metrics
    totalRevenue: 'Total Revenue',
    totalOperations: 'Total Operations',
    activeCustomers: 'Active Customers',
    apiProducts: 'API Products',
    fromLastMonth: 'from last month',
    subscribed: '{{count}} Subscribed',
    credits: '{{count}} Credits',
    
    // Charts
    revenueTrend: 'Revenue Trend',
    revenueTrendDescription: 'Daily revenue over the last 6 weeks',
    operationsTrend: 'Operations Trend',
    operationsTrendDescription: 'API calls and automation runs over time',
    totalCalls: 'Total Calls',
    
    // Sections
    quickActions: 'Quick Actions',
    quickActionsDescription: 'Common tasks and workflows',
    topConsumers: 'Top Consumers',
    topConsumersDescription: 'Your highest usage customers this month',
    statusAlerts: 'Status & Alerts',
    statusAlertsDescription: 'System health and important notifications',
    
    // Quick Actions
    createApiProduct: 'Create API Product',
    inviteCustomer: 'Invite Customer',
    updateDocumentation: 'Update Documentation',
    configureStripe: 'Configure Stripe',
    manageProducts: 'Manage products',
    
    // Status
    allSystemsOperational: 'All systems operational',
    apiGatewayNormal: 'API gateway responding normally',
    highUsageWarning: 'High usage on {{product}}',
    considerScaling: 'Consider scaling or rate limiting',
    viewProduct: 'View Product',
    
    // Additional translations
    healthy: '{{count}} healthy',
    warnings: '{{count}} warnings',
    details: 'Details',
    dailyRevenue: 'Daily revenue over the last 6 weeks',
    apiCallsAndAutomation: 'API calls and automation runs over time',
    commonTasks: 'Common tasks and workflows',
    viewAll: 'View all',
    highestUsageCustomers: 'Your highest usage customers this month',
    operations: 'operations',
    systemHealth: 'System health and important notifications',
    highUsageWeatherApi: 'High usage on Weather API',
    operationsBreakdown: {
      api: '{{percent}}% API',
      automation: '{{percent}}% Automation',
    },
  } as const;

export default dashboard;
